<template>
  <ion-page>
    <ion-content>
      <LargeNavbar
        @backButton="backButton"
        show-back-button
        is-large
        show-edit
        :title="t('profile.myProfileTitle')"
      />
      <div class="PageContainer w-100 d-flex">
        <div class="content w-100">
          <ProfileCard in-profile-view expanded />
        </div>
        <template v-if="user?.name">
          <div class="content w-100 mt-xs">
            <ProfileContactData />
          </div>
          <div class="content w-100 mt-xs">
            <ProfileMoreAbout />
          </div>
        </template>
        <template v-else>
          <ion-icon color="body" :icon="personOutline" size="large" class="mt-32"></ion-icon>
          <h2 class="h2 text-weight-bold ext-extra-lg text-color-placeholder text-align-center">
            {{ t('profile.notPersonalData') }}
          </h2>
          <ion-button
            class="mt-16"
            expand="block"
            fill="solid"
            color="primary"
            @click="toggleEditProfile = true"
          >{{ t('actions.complete') }}
          </ion-button
          >
        </template>
        <div class="content w-100 d-flex" v-if="user?.createdAt">
          <ion-label
            class="w-100 text-weight-bold text-align-center ion-padding ion-justify-content-center ion-align-items-center text-color-placeholder text-xs"
          >
            {{ t('profile.createdOn') }} {{ formatDateTime(user!.createdAt, locale, true, true) }}
          </ion-label>
        </div>
      </div>
    </ion-content>
    <ion-modal
      id="profile-edit"
      :is-open="toggleEditProfile"
      :initial-breakpoint="0.98"
      :breakpoints="[0, 0.25, 0.5, 0.7, 0.98]"
      @will-dismiss="toggleEditProfile = false"
    >
      <ProfileEdit />
    </ion-modal>
    <ion-modal
      id="profile-document"
      :is-open="toggleDocument"
      :initial-breakpoint="0.7"
      :breakpoints="[0, 0.25, 0.7]"
      @will-dismiss="toggleDocument = false"
    >
      <div class="ion-padding bg-white h-100">
        <DocumentListForm hide-return></DocumentListForm>
      </div>
    </ion-modal>
  </ion-page>
</template>
<script setup lang="ts">
  import { IonContent, IonModal, IonPage, IonLabel, IonIcon, IonButton } from '@ionic/vue';
  import LargeNavbar from '@/components/LargeNavbar.vue';
  import ProfileCard from '@/components/shared/ProfileCard.vue';
  import { useI18n } from 'vue-i18n';
  import ProfileEdit from '@/components/profile/ProfileEdit.vue';
  import { useProfile } from '@/composables/useProfile';
  import ProfileContactData from '@/components/shared/ProfileContactData.vue';
  import router from '@/router';
  import ProfileMoreAbout from '@/components/shared/ProfileMoreAbout.vue';
  import { useAuth } from '@/composables/useAuth';
  import { formatDateTime } from '@/utils/date-utils';
  import { personOutline } from 'ionicons/icons';
  import DocumentListForm from '@/components/booking/DocumentListForm.vue';
  import { onMounted } from 'vue';

  const { toggleEditProfile, toggleDocument } = useProfile();
  const { user } = useAuth();

  const { t, locale } = useI18n();

  const backButton = () => {
    router.back();
  };

  onMounted(() => {
    toggleDocument.value = false;
    toggleEditProfile.value = false;
  });

</script>
<style scoped lang="scss">
  ion-modal {
    --border-radius: 25px;
    --background: var(--ion-color-body);
  }

  ion-content.profile-edit {
    --border-radius: 25px;
    --background: white;
    overflow-y: scroll;
  }
</style>
